module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"contactUs":"Contact us","about":"About","legalNotice":"Legal Notice"},"fr":{"contactUs":"Nous contacter","about":"A propos","legalNotice":"Mentions légales"}}')
  delete Component.options._Ctor
}
